import { Box, Grid } from '@mui/material';
import { StepButton, StepTypography } from 'shell/components/shared/step-button';
import { PmiButton } from 'shell/components/shared/button';
import { StickyDiv } from 'shell/components/shared/sticky-div';
import { SubscriptionForeignResidenceStep } from 'subscription/context/aire-subscription';

interface ForeignResidenceButtonsProps {
  handleExit: () => void;
  currentStep: SubscriptionForeignResidenceStep;
  onPressStep: (step: SubscriptionForeignResidenceStep) => void;
  onConfirm?: () => void;
}

const ForeignResidenceButtons: React.FC<ForeignResidenceButtonsProps> = ({
  handleExit,
  currentStep,
  onPressStep,
  onConfirm,
}: ForeignResidenceButtonsProps) => {
  return (
    <Grid item xs={12} md={2}>
      <StickyDiv>
        <Grid container spacing={1}>
          <Grid item xs={12}>
            <StepButton
              active={currentStep === SubscriptionForeignResidenceStep.RegistryOffice}
              fullWidth
              variant="outlined"
              color="cdmBrandThird"
              onClick={() => onPressStep(SubscriptionForeignResidenceStep.RegistryOffice)}
            >
              <StepTypography
                active={currentStep === SubscriptionForeignResidenceStep.RegistryOffice}
              >
                Anagrafe
              </StepTypography>
            </StepButton>
          </Grid>
          <Grid item xs={12}>
            <StepButton
              active={currentStep === SubscriptionForeignResidenceStep.Family}
              fullWidth
              variant="outlined"
              color="cdmBrandThird"
              onClick={() => onPressStep(SubscriptionForeignResidenceStep.Family)}
              disabled={currentStep < SubscriptionForeignResidenceStep.Family}
            >
              <StepTypography
                active={currentStep === SubscriptionForeignResidenceStep.Family}
                disabled={currentStep < SubscriptionForeignResidenceStep.Family}
              >
                Famiglia
              </StepTypography>
            </StepButton>
          </Grid>
          <Grid item xs={12}>
            <StepButton
              active={currentStep === SubscriptionForeignResidenceStep.Reesidence}
              fullWidth
              variant="outlined"
              color="cdmBrandThird"
              onClick={() => onPressStep(SubscriptionForeignResidenceStep.Reesidence)}
              disabled={currentStep < SubscriptionForeignResidenceStep.Reesidence}
            >
              <StepTypography
                active={currentStep === SubscriptionForeignResidenceStep.Reesidence}
                disabled={currentStep < SubscriptionForeignResidenceStep.Reesidence}
              >
                Residenza
              </StepTypography>
            </StepButton>
          </Grid>
          <Grid item xs={12}>
            <StepButton
              active={currentStep === SubscriptionForeignResidenceStep.Attachments}
              fullWidth
              variant="outlined"
              color="cdmBrandThird"
              onClick={() => onPressStep(SubscriptionForeignResidenceStep.Attachments)}
              disabled={currentStep < SubscriptionForeignResidenceStep.Attachments}
            >
              <StepTypography
                active={currentStep === SubscriptionForeignResidenceStep.Attachments}
                disabled={currentStep < SubscriptionForeignResidenceStep.Attachments}
              >
                Allegati
              </StepTypography>
            </StepButton>
          </Grid>
        </Grid>
        <div className="pmi-pt-4">
          <div className="pmi-pb-2">
            <PmiButton
              color="cdmBrandThird"
              variant="outlined"
              id="submit"
              fullWidth
              type="submit"
              disabled={currentStep < SubscriptionForeignResidenceStep.Attachments}
              onClick={onConfirm}
            >
              Conferma
            </PmiButton>
          </div>
          <div className="pmi-pb-2">
            <PmiButton
              color="cdmBrand"
              variant="contained"
              id="deny-operation"
              fullWidth
              onClick={handleExit}
            >
              <Box
                sx={{
                  textOverflow: 'ellipsis',
                  overflow: 'hidden',
                  whiteSpace: 'nowrap',
                }}
              >
                Annulla Operazione
              </Box>
            </PmiButton>
          </div>
        </div>
      </StickyDiv>
    </Grid>
  );
};

ForeignResidenceButtons.displayName = 'Buttons subscriptions foreign residence component';

export default ForeignResidenceButtons;
